export default {
  validateReferral: `${process.env.REACT_APP_API_ENDPOINT}/api/v1/policy/validate_referral_code/`,
}



// WEBPACK FOOTER //
// ./src/request/urls/url.js